<bw-section-card-legacy [header]="'LOAN_MENU_OVERVIEW_SECTION_HEADER' | translate">
  <ng-template #wrappedContent>
    <bw-cell-legacy
      *ngIf="!!loan.statusDisplayName"
      [labelSubLeft]="'LOAN_MENU_STATUS' | translate"
      [labelSubRight]="loan.statusDisplayName"
      leftLabelColor="--secondary-text"
      [separatorType]="false ? 'none' : 'full'"
    >
    </bw-cell-legacy>
    <bw-cell-legacy
      *ngIf="!!loan.paymentAmount"
      [labelSubLeft]="'LOAN_MENU_PAYMENT_AMOUNT' | translate"
      [labelSubRight]="loan.paymentAmount | currency"
      leftLabelColor="--secondary-text"
      [separatorType]="false ? 'none' : 'full'"
    >
    </bw-cell-legacy>
    <bw-cell-legacy
      *ngIf="!!loan.nextPaymentDate"
      [labelSubLeft]="'LOAN_MENU_NEXT_PAYMENT_DATE' | translate"
      [labelSubRight]="loan.nextPaymentDate | date : 'MMM d, yyyy'"
      leftLabelColor="--secondary-text"
      [separatorType]="false ? 'none' : 'full'"
    >
    </bw-cell-legacy>
    <bw-cell-legacy
      *ngIf="!!loan.loanAmount"
      [labelSubLeft]="'LOAN_MENU_AMOUNT_BORROWED' | translate"
      [labelSubRight]="loan.loanAmount | currency"
      leftLabelColor="--secondary-text"
      [separatorType]="false ? 'none' : 'full'"
    >
    </bw-cell-legacy>
    <bw-cell-legacy
      *ngIf="!!loan.approvalDate"
      [labelSubLeft]="'LOAN_MENU_DATE_OPENED' | translate"
      [labelSubRight]="loan.approvalDate | date : 'MMM d, yyyy'"
      leftLabelColor="--secondary-text"
      [separatorType]="false ? 'none' : 'full'"
    >
    </bw-cell-legacy>
    <bw-cell-legacy
      *ngIf="!!loan.loanTerm"
      [labelSubLeft]="'LOAN_MENU_TERM' | translate"
      [labelSubRight]="'LOAN_TERM_VALUE' | translate : { loanTerm: loan.loanTerm }"
      leftLabelColor="--secondary-text"
      [separatorType]="false ? 'none' : 'full'"
    >
    </bw-cell-legacy>
    <bw-cell-legacy
      *ngIf="!!loan.apr"
      [labelSubLeft]="'LOAN_MENU_APR' | translate"
      [labelSubRight]="'LOAN_APR_VALUE' | translate : { aprValue: loan.apr }"
      leftLabelColor="--secondary-text"
      [separatorType]="false ? 'none' : 'full'"
    >
    </bw-cell-legacy>
    <bw-cell-legacy
      *ngIf="!!loan.lastUpdated"
      [labelSubLeft]="'LOAN_MENU_LAST_UPDATED_DATE' | translate"
      [labelSubRight]="loan.lastUpdated | date : 'MMM d, yyyy'"
      leftLabelColor="--secondary-text"
      [separatorType]="false ? 'none' : 'full'"
    >
    </bw-cell-legacy>
  </ng-template>
</bw-section-card-legacy>
